import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, LinkSize } from '@redis-ui/components';
import { i18translation } from '../../locale/translations/i18NsPaths';

interface ReadMoreProps {
  children?: ReactNode;
  readMoreLink: string;
  dataTestId?: string;
  className?: string;
  withText?: boolean;
  size?: LinkSize;
  onClick?: () => void;
}

const ReadMore = ({
  readMoreLink,
  dataTestId,
  children,
  withText = true,
  onClick,
  ...restProps
}: ReadMoreProps) => {
  const { t } = useTranslation();
  const keyPrefix = i18translation.labels;

  return (
    <Link
      variant="inline"
      external
      href={readMoreLink}
      data-testid={dataTestId || 'link--read-more'}
      onClick={onClick}
      {...restProps}
    >
      {withText ? (children ?? t(keyPrefix.readMore)) : ' '}
    </Link>
  );
};

export default ReadMore;
